/* Stonepacker NL/EN client-side translation toggle.
   Walks DOM text nodes, normalizes whitespace, matches against dictionary, swaps content.
   Stores preference in localStorage. */
(function() {
  // Helper: normalize whitespace — collapses newlines and multiple spaces to single space
  function norm(s) { return s.replace(/\s+/g, ' ').trim(); }

  const NL_TO_EN = {
    "Producten": "Products",
    "Voor webshops": "For webshops",
    "Voor interne logistiek": "For internal logistics",
    "Interne logistiek": "Internal logistics",
    "Duurzaamheid": "Sustainability",
    "FAQ": "FAQ",
    "Stuur me een sample": "Send me a sample",
    "Verzendverpakking van steen, niet van bomen": "Shipping packaging from stone, not trees",
    "Verstuur": "Ship",
    "karton-vrij": "cardboard-free",
    "Steenpapier dat": "Stone paper that",
    "blijft terugkomen": "keeps coming back",
    "Bekijk hoe het werkt": "See how it works",
    "Voor interne logistiek?": "For internal logistics?",
    "Bekijk maatwerk-aankoop": "Explore custom purchase",
    "Bekijk maatwerk-aankoop →": "Explore custom purchase →",
    "B-Corp": "B-Corp",
    "gecertificeerd": "certified",
    "Stone Paper Alliance": "Stone Paper Alliance",
    "partner": "partner",
    "BOXO": "BOXO",
    "retournetwerk": "return network",
    "De herbruikbare verzendverpakking van MOYU. Klant levert in bij BOXO, krijgt 3,95 euro statiegeld terug. Wij reinigen, sturen schoon retour. Tot 25 keer.": "MOYU's reusable shipping packaging. Customer drops off at BOXO, gets €3.95 deposit back. We clean, ship back to your warehouse. Up to 25 times.",
    "Stonepacker. Herbruikbare verzenddoos van steenpapier.": "Stonepacker. Reusable shipping box made of stone paper.",
    "Vertrouwd door MOYU's klanten": "Trusted by MOYU's customers",
    "De Stonepacker familie": "The Stonepacker family",
    "Twee producten.": "Two products.",
    "Eén materiaal": "One material",
    ". Geen karton.": ". No cardboard.",
    "Pay-per-shipment of maatwerk. Niet wat je zoekt? Vraag een aangepaste maat (vanaf 1.000 stuks).": "Pay-per-shipment or custom. Not what you need? Ask us for a custom size (from 1,000 units).",
    "Box": "Box",
    "Envelope": "Envelope",
    "Stonepacker Box": "Stonepacker Box",
    "Stonepacker Envelope": "Stonepacker Envelope",
    "Herbruikbare verzenddoos voor 3D-items: kleding, boeken, food, accessoires. Vouwbaar, waterproof, scheurbestendig.": "Reusable shipping box for 3D items: clothing, books, food, accessories. Foldable, waterproof, tear-resistant.",
    "Herbruikbare envelop voor gifts, kaarten, sieraden en platte items. Waterproof en scheurbestendig.": "Reusable envelope for gifts, cards, jewelry and flat items. Waterproof and tear-resistant.",
    "Standaardmaat": "Standard size",
    "Standaardmaten": "Standard sizes",
    "M nu, L en XL volgen": "M now, L and XL coming",
    "Hergebruik": "Reuse",
    "20+ rondes": "20+ cycles",
    "Maatwerk vanaf": "Custom from",
    "1.000 stuks": "1,000 units",
    "Max afmeting": "Max dimensions",
    "~30×30×20 cm*": "~30×30×20 cm*",
    "Bedrukking": "Printing",
    "Flexodruk (beperkt)": "Flexo print (limited)",
    "Full colour": "Full colour",
    "Use case": "Use case",
    "Gift & flat items": "Gift & flat items",
    "Sample aanvragen": "Request a sample",
    "Offerte aanvragen": "Request a quote",
    "Stonepacker Box, open en uitgevouwen": "Stonepacker Box, open and unfolded",
    "Stonepacker Envelope, herbruikbare verzendenvelop van steenpapier": "Stonepacker Envelope, reusable shipping envelope made of stone paper",
    "* Maximale enkelblads-productie wordt bepaald door de plaatmaat steenpapier-corrugated van 1 bij 1 meter. Grotere afmetingen kunnen via meer-delige constructie. In overleg.": "* Maximum single-sheet production is determined by the corrugated stone paper sheet size of 1 by 1 meter. Larger dimensions are possible via multi-part construction. In consultation.",
    "Self-service · gratis": "Self-service · free",
    "Stuur me een sample.": "Send me a sample.",
    "Eerst zelf voelen? Vul in, binnen 3 werkdagen ligt een gratis sample bij je.": "Want to feel it first? Fill in below, your free sample arrives within 3 business days.",
    "Bedrijfsnaam": "Company name",
    "Naam": "Name",
    "E-mail": "Email",
    "Welk product?": "Which product?",
    "Box + Envelope (aanbevolen)": "Box + Envelope (recommended)",
    "Alleen Box": "Box only",
    "Alleen Envelope": "Envelope only",
    "Verzendadres": "Shipping address",
    "Verstuur sample-aanvraag": "Send sample request",
    "We versturen binnen 3 werkdagen.": "We ship within 3 business days.",
    "Top! Je sample-aanvraag is binnen. We sturen hem binnen 3 werkdagen op.": "Got it! Your sample request is in. We ship it within 3 business days.",
    "Bijv. Studio Limonade": "E.g. Studio Limonade",
    "Straat 1, 1234 AB Plaats": "Street 1, 1234 AB City",
    "Box, envelope, of beide. Jij kiest.": "Box, envelope, or both. You choose.",
    "Inclusief technische datasheet en LCA-samenvatting": "Includes technical datasheet and LCA summary",
    "Geen verplichting. Voel het materiaal.": "No obligation. Feel the material.",
    "Roel reageert binnen 1 werkdag": "Roel responds within 1 business day",
    "Twee manieren om Stonepacker af te nemen": "Two ways to use Stonepacker",
    "Service of maatwerk-aankoop?": "Service or custom purchase?",
    "Pay-per-shipment voor je webshop of maatwerk voor interne logistiek. Eén materiaal, twee routes weg van karton.": "Pay-per-shipment for your webshop or custom for internal logistics. One material, two routes away from cardboard.",
    "Primair": "Primary",
    "Propositie A, service": "Proposition A, service",
    "Pay per shipment. Klant levert in bij een BOXO-punt, krijgt €3,95 statiegeld terug.": "Pay per shipment. Customer drops at a BOXO point, gets €3.95 deposit back.",
    "Beide producten (Box + Envelope) beschikbaar": "Both products (Box + Envelope) available",
    "Plug-and-play met Shopify, WooCommerce, Sendcloud": "Plug-and-play with Shopify, WooCommerce, Sendcloud",
    "Landelijke retournetwerk via BOXO (incl. statiegeld)": "Nationwide return network via BOXO (incl. deposit)",
    "Reiniging, controle en vervanging is bij ons inbegrepen": "Cleaning, inspection and replacement included",
    "Bekijk webshop-oplossing": "Explore webshop solution",
    "Propositie B, maatwerk": "Proposition B, custom",
    "Eigen interne loop. Warehouse-to-store, B2B-leveringen. Maatwerk in afmetingen, sluiting en bedrukking.": "Your own internal loop. Warehouse-to-store, B2B deliveries. Custom dimensions, closure and print.",
    "Maatwerk afmetingen vanaf MOQ 1.000 stuks": "Custom dimensions from MOQ 1,000 units",
    "Max enkelblad ~30×30×20 cm (plaat 1×1 m)": "Max single sheet ~30×30×20 cm (sheet 1×1 m)",
    "Custom branding, sluitingstype, sleeves": "Custom branding, closure type, sleeves",
    "Cradle-to-cradle, wij recyclen einde levensduur": "Cradle-to-cradle, we recycle end of life",
    "Bekijk maatwerk-oplossing": "Explore custom solution",
    "rondes per Stonepacker": "cycles per Stonepacker",
    "minder CO₂ dan karton": "less CO₂ than cardboard",
    "minder CO2 dan karton": "less CO2 than cardboard",
    "minder energie in productie": "less energy in production",
    "water in productie": "water in production",
    "verzenddozen per jaar in NL": "shipping boxes per year in NL",
    "De": "The",
    "lelijke waarheid": "ugly truth",
    "achter elk pakket": "behind every parcel",
    "Stonepacker versus eenmalig karton, herbruikbaar wint": "Stonepacker versus single-use cardboard, reusable wins",
    "Elk jaar 300+ miljoen eenmalige verzenddozen in de Nederlandse afvalstroom. Bergen verpakking, voor één korte reis.": "Each year 300M+ single-use shipping boxes hit the Dutch waste stream. Mountains of packaging, for one short trip.",
    "Stonepacker draait het om. Eén pakket, minimaal 20 reizen. Geen bomen, geen wegwerpcyclus.": "Stonepacker flips it. One package, at least 20 trips. No trees, no throwaway cycle.",
    "Waarom Stonepacker": "Why Stonepacker",
    "Sterker dan karton.": "Stronger than cardboard.",
    "Slimmer": "Smarter",
    "dan plastic.": "than plastic.",
    "Steenpapier: uitstraling van papier, duurzaamheid van een industrieel materiaal.": "Stone paper: the look of paper with the durability of an industrial material.",
    "Boomvrij gemaakt": "Tree-free",
    "Boomvrij": "Tree-free",
    "Reststeen uit groeves (calciumcarbonaat) en gerecycled HDPE. Geen bomen, geen water, geen bleek.": "Quarry waste (calcium carbonate) and recycled HDPE. No trees, no water, no bleach.",
    "Echt herbruikbaar": "Truly reusable",
    "20+ rondes per Stonepacker. Waterproof, scheurbestendig, makkelijk te reinigen. Einde-leven volledig recyclebaar.": "20+ cycles per Stonepacker. Waterproof, tear-resistant, easy to clean. Fully recyclable at end of life.",
    "Cradle-to-cradle": "Cradle-to-cradle",
    "Geen afvalstroom. Einde-leven gaat retour naar onze fabriek en wordt nieuw steenpapier.": "No waste stream. End of life goes back to our factory and becomes new stone paper.",
    "Hoe het werkt": "How it works",
    "Twee flows, één missie.": "Two flows, one mission.",
    "Twee flows,": "Two flows,",
    "een missie": "one mission",
    "Het proces voor jouw use case.": "The process for your use case.",
    "Webshop-flow": "Webshop flow",
    "Stap 1": "Step 1",
    "Stap 2": "Step 2",
    "Stap 3": "Step 3",
    "Stap 4": "Step 4",
    "Webshop verstuurt": "Webshop ships",
    "Verstuur orders in een Stonepacker via je gewone fulfilment.": "You ship orders in a Stonepacker via your usual fulfilment.",
    "Klant ontvangt": "Customer receives",
    "Je klant pakt uit en ziet een QR-code voor de retour-instructie.": "Your customer unpacks and sees a QR code with return instructions.",
    "Inleveren bij BOXO": "Drop off at BOXO",
    "Klant levert in bij een lokaal BOXO-punt en krijgt €3,95 statiegeld terug.": "Customer drops at a local BOXO point and gets €3.95 deposit back.",
    "Terug in roulatie": "Back in rotation",
    "Wij reinigen, controleren en sturen schoon retour.": "We clean, inspect and ship clean back to your warehouse.",
    "Maatwerk intake": "Custom intake",
    "We bespreken use case, dimensies (max ~30×30×20 cm), sluiting, bedrukking en volume (vanaf MOQ 1.000).": "We discuss use case, dimensions (max ~30×30×20 cm), closure, printing and volume (from MOQ 1,000).",
    "Sample & test": "Sample & test",
    "Je ontvangt prototypes binnen 2-4 weken om in jouw eigen flow te valideren.": "You receive prototypes within 2-4 weeks to validate in your own flow.",
    "Productie & levering": "Production & delivery",
    "Definitieve order, productie + levering binnen 4-8 weken.": "Final order, production + delivery within 4-8 weeks.",
    "Jouw loop, ons recyclen": "Your loop, our recycling",
    "Jij beheert je interne retourstroom. Aan einde levensduur recyclen we de Stonepackers tot nieuw steenpapier.": "You manage your internal return flow. End of life we recycle the Stonepackers into new stone paper.",
    "Stonepacker vs alternatieven": "Stonepacker vs alternatives",
    "Hoe scoort Stonepacker?": "How does Stonepacker score?",
    "Eerlijke vergelijking. Geen marketingmist.": "Honest comparison. No marketing fog.",
    "Maatstaf": "Metric",
    "Eigenschap": "Feature",
    "Stonepacker": "Stonepacker",
    "Karton (eenmalig)": "Cardboard (single-use)",
    "Plastic herbruikbaar (PP)": "Reusable plastic (PP)",
    "PP-bak": "PP container",
    "Grondstof": "Raw material",
    "Calciumcarbonaat (steen)": "Calcium carbonate (stone)",
    "Houtpulp uit bossen": "Wood pulp from forests",
    "Houtpulp (bomen)": "Wood pulp (trees)",
    "Aardolie (PP-granulaat)": "Petroleum (PP granulate)",
    "Aardolie (fossiel)": "Petroleum (fossil)",
    "Reststeen + gerecycled HDPE": "Quarry stone + recycled HDPE",
    "Aantal rondes": "Number of cycles",
    "Hergebruik per stuk": "Reuse per unit",
    "1 keer": "1 time",
    "30 tot 50 keer": "30 to 50 times",
    "20 tot 25 keer": "20 to 25 times",
    "Tot 25": "Up to 25",
    "1 (5-6x als bestelbox)": "1 (5-6x as order box)",
    "Tot 20 (PP doos), 80 (PP zak)": "Up to 20 (PP box), 80 (PP bag)",
    "CO₂ in productie": "CO₂ in production",
    "CO2 per ronde": "CO2 per cycle",
    "~0,03 kg (na 25x)": "~0.03 kg (after 25x)",
    "~0,42 kg eenmalig": "~0.42 kg single-use",
    "~0,18 kg (na 20x)": "~0.18 kg (after 20x)",
    "Hoog (gemiddeld 1.300 g/kg)": "High (avg 1,300 g/kg)",
    "Hoog (~1.800 g/kg, fossiel)": "High (~1,800 g/kg, fossil)",
    "67% lager dan papier": "67% lower than paper",
    "100% (referentie)": "100% (reference)",
    "CO₂ per zending (na hergebruik)": "CO₂ per shipment (after reuse)",
    "Watergebruik in productie": "Water use in production",
    "Water in productie": "Water in production",
    "0 liter": "0 liters",
    "20-50 liter per kg": "20-50 liters per kg",
    "~5 liter per kg": "~5 liters per kg",
    "~50.000 L/ton": "~50,000 L/ton",
    "~1.000 L/ton": "~1,000 L/ton",
    "~30 L/ton": "~30 L/ton",
    "Energie in productie": "Energy in production",
    "Energie productie": "Energy production",
    "Referentie": "Reference",
    "85% minder dan karton": "85% less than cardboard",
    "~50% lager": "~50% lower",
    "Hoog": "High",
    "Zeer hoog (fossiel)": "Very high (fossil)",
    "Bomen gekapt": "Trees cut",
    "Spatwaterproof": "Water-splashproof",
    "Waterproof en scheurbestendig": "Waterproof and tear-resistant",
    "Ja, van nature": "Yes, naturally",
    "Nee, vergt coating": "No, requires coating",
    "✓ Ja, van nature": "✓ Yes, naturally",
    "✗ Nee, vergt coating": "✗ No, requires coating",
    "✓ Ja": "✓ Yes",
    "Ja": "Yes",
    "Geen": "None",
    "Scheurvast": "Tear-resistant",
    "Laag": "Low",
    "Statiegeld systeem": "Deposit system",
    "BOXO 3,95 euro (consumer)": "BOXO 3.95 euro (consumer)",
    "BOXO statiegeld variabel": "BOXO deposit variable",
    "Einde levensduur": "End of life",
    "Recyclebaar einde levensduur": "Recyclable end of life",
    "Retour, vermalen, nieuw steenpapier": "Return, grind, new stone paper",
    "Oud papier": "Old paper",
    "Recycle naar lagere kwaliteit": "Recycle to lower quality",
    "Beperkt, vezels degraderen na 5 cycli": "Limited, fibers degrade after 5 cycles",
    "Beperkt, downcyclen tot lagere kwaliteit": "Limited, downcycle to lower quality",
    "Volledig, terug naar nieuw steenpapier": "Fully, back to new stone paper",
    "Print en branding": "Print and branding",
    "Volledig bedrukbaar": "Fully printable",
    "Beperkt (sticker)": "Limited (sticker)",
    "Bronnen: MOYU LCA-rapport, Packaging Insights LCA-databank, Stone Paper Solutions, EU-PPWR referentiewaarden. Cijfers indicatief, vraag het datasheet voor jouw use case.": "Sources: MOYU LCA report, Packaging Insights LCA database, Stone Paper Solutions, EU PPWR reference values. Figures are indicative, request the datasheet for your use case.",
    "Vaak gevraagd": "Frequently asked",
    "Veelgestelde vragen": "Frequently asked questions",
    "Veelgestelde": "Frequently asked",
    "vragen": "questions",
    "Geschreven om jouw vragen, én die van AI-zoekmachines, direct te beantwoorden.": "Written to answer your questions, and those of AI search engines, directly.",
    "Wat is een Stonepacker precies?": "What exactly is a Stonepacker?",
    "Een Stonepacker is een herbruikbare verpakking gemaakt van steenpapier, een combinatie van calciumcarbonaat (gemalen reststeen uit groeves) en gerecycled HDPE-plastic. Stonepacker bestaat in twee uitvoeringen (Box en Envelope) en is af te nemen als service voor webshops of als maatwerk-aankoop.": "A Stonepacker is a reusable package made of stone paper, a combination of calcium carbonate (ground quarry waste) and recycled HDPE plastic. Stonepacker comes in two versions (Box and Envelope) and is available as a service for webshops or as a custom purchase.",
    "Hoeveel keer kan een Stonepacker hergebruikt worden?": "How many times can a Stonepacker be reused?",
    "Gemiddeld 20 tot 25 retourcycli, daarna recyclen we hem tot nieuw steenpapier. Door de tear-resistant en waterproof eigenschappen blijft de verpakking aanzienlijk langer in roulatie dan karton.": "On average 20 to 25 return cycles, then we recycle it into new stone paper. Thanks to the tear-resistant and waterproof properties, the packaging stays in circulation considerably longer than cardboard.",
    "Kan Stonepacker op maat gemaakt worden?": "Can Stonepacker be made to measure?",
    "Ja, voor maatwerk geldt een minimum order van 1.000 stuks per ordergroep. De maximale plaatmaat steenpapier-corrugated is 1×1 meter, wat de uiterste box-afmeting bepaalt op ongeveer 30×30×20 cm voor enkelblads-productie. Grotere afmetingen zijn mogelijk via meer-delige constructie, in overleg.": "Yes, for custom orders the minimum is 1,000 units per order group. The maximum sheet size of corrugated stone paper is 1×1 meter, which sets the maximum box dimension at approximately 30×30×20 cm for single-sheet production. Larger dimensions are possible via multi-part construction, in consultation.",
    "Hoe vraag ik een sample aan?": "How do I request a sample?",
    "Vul het sample-formulier op deze pagina in (Box, Envelope, of beide). We sturen je sample binnen 3 werkdagen gratis op, inclusief technische datasheet. Geen verplichtingen.": "Fill in the sample form on this page (Box, Envelope, or both). We'll ship your free sample within 3 business days, including technical datasheet. No obligations.",
    "Wat is het verschil tussen jullie webshop-service en de maatwerk-aankoop?": "What's the difference between your webshop service and the custom purchase?",
    "In de webshop-service betaal je per zending; je klant levert in bij BOXO en krijgt €3,95 statiegeld terug. Bij maatwerk-aankoop koop je de Stonepackers eenmalig voor je interne logistieke loop, geen statiegeld, jij beheert je eigen retourstroom.": "In the webshop service you pay per shipment; your customer drops off at BOXO and gets €3.95 deposit back. With custom purchase you buy the Stonepackers once for your internal logistics loop, no deposit, you manage your own return flow.",
    "Hoeveel CO₂ bespaart Stonepacker ten opzichte van karton?": "How much CO₂ does Stonepacker save compared to cardboard?",
    "Bij hergebruik bespaart Stonepacker tot 90% CO₂ ten opzichte van eenmalig karton. De productie van steenpapier zelf heeft een 94% lagere CO₂-voetafdruk dan klassiek papier omdat er geen bomen, water of bleekmiddelen aan te pas komen.": "With reuse Stonepacker saves up to 90% CO₂ compared to single-use cardboard. The production of stone paper itself has a 94% lower CO₂ footprint than classical paper because no trees, water or bleach are involved.",
    "Praat met Roel": "Talk to Roel",
    "Klaar om karton": "Ready to send cardboard",
    "de deur uit": "out the door",
    "te doen?": "?",
    "Liever direct sparren? Roel denkt mee over wat past bij je shop of interne logistiek.": "Prefer to spar directly? Roel will think along about what fits your shop or internal logistics.",
    "Klaar om te beginnen?": "Ready to start?",
    "Stuur me een sample,": "Send me a sample,",
    "ik bel je terug": "I'll call you back",
    "Plan een belafspraak": "Schedule a call",
    "Mail": "Mail",
    "Bel": "Call",
    "WhatsApp": "WhatsApp",
    "Roel": "Roel",
    "Roel met een Stonepacker box": "Roel with a Stonepacker box",
    "Roel, oprichter MOYU": "Roel, founder MOYU",
    "Roel met een Stonepacker": "Roel with a Stonepacker",
    "Stonepacker is een initiatief van MOYU, B-Corp gecertificeerd en pionier in steenpapier-toepassingen.": "Stonepacker is an initiative by MOYU, B-Corp certified and pioneer in stone paper applications.",
    "Oplossingen": "Solutions",
    "Contact & legal": "Contact & legal",
    "MOYU notebooks": "MOYU notebooks",
    "Algemene voorwaarden": "Terms & Conditions",
    "Privacy policy": "Privacy policy",
    "Stonepacker inleveren": "Return a Stonepacker",
    "BOXO partner": "BOXO partner",
    "Case studies": "Case studies",
    "© 2026 Stonepacker · MOYU B.V.": "© 2026 Stonepacker · MOYU B.V.",
    "Hoe werkt": "How does",
    "BOXO?": "BOXO work?",
    "Hetzelfde pakket, twee perspectieven. Voor je klant betekent het 3,95 euro statiegeld terug. Voor jou als webshop betekent het 1,30 euro per zending plus geen voorraadrisico.": "Same package, two perspectives. For your customer it means 3.95 euro deposit back. For you as webshop it means 1.30 euro per shipment plus no inventory risk.",
    "Voor je klant": "For your customer",
    "Bestel, pak uit, lever in": "Order, unbox, drop off",
    "De Stonepacker komt thuis. Pakje uit, leg de doos plat, scan de QR-code, lever in bij het dichtstbijzijnde BOXO-punt en het statiegeld komt terug op de rekening.": "The Stonepacker comes home. Unpack, lay it flat, scan the QR code, drop at the nearest BOXO point and the deposit returns to the bank account.",
    "Bestelling komt aan in een Stonepacker": "Order arrives in a Stonepacker",
    "Uitpakken, doos plat vouwen": "Unpack, fold flat",
    "QR-code scannen, dichtstbijzijnde BOXO-punt zoeken": "Scan QR code, find nearest BOXO point",
    "3,95 euro statiegeld terug op rekening": "3.95 euro deposit back on account",
    "Statiegeld terug per Stonepacker, via 2.500+ BOXO inleverpunten in NL": "Deposit back per Stonepacker, via 2,500+ BOXO drop-off points in NL",
    "Vind een BOXO-punt": "Find a BOXO point",
    "Voor je webshop": "For your webshop",
    "Pay per shipment, geen voorraad": "Pay per shipment, no inventory",
    "Geen 1.000 dozen op kantoor. Bij elke verzending krijg je een Stonepacker geleverd voor 1,30 euro per usage. De klant brengt hem terug, wij reinigen en hij komt schoon terug naar je magazijn.": "No 1,000 boxes on the office floor. Each shipment, we deliver a Stonepacker for 1.30 euro per usage. The customer brings it back, we clean it and it returns clean to your warehouse.",
    "Vraag voorraad Stonepackers aan, je betaalt per gebruik": "Request Stonepackers stock, you pay per use",
    "1,30 euro per usage, je verstuurt orders zoals altijd": "1.30 euro per usage, you ship orders as usual",
    "Klant brengt hem terug bij BOXO": "Customer brings it back at BOXO",
    "Wij reinigen, controleren en leveren schoon terug": "We clean, inspect and deliver clean",
    "1,30 euro": "1.30 euro",
    "3,95 euro": "3.95 euro",
    "Per zending, ex BTW. Geen abonnement, geen minimum afname.": "Per shipment, ex VAT. No subscription, no minimum order.",
    "Plan kennismaking": "Schedule intro call",
    "Geinspireerd over": "Inspired by",
    "steenpapier?": "stone paper?",
    "Steenpapier zit niet alleen in Stonepacker. MOYU maakt al jaren herbruikbare notebooks, agendas en flipovers van hetzelfde materiaal. Misschien iets voor jou.": "Stone paper isn't only in Stonepacker. MOYU has been making reusable notebooks, agendas and flipovers from the same material for years. Maybe something for you.",
    "MOYU Notebook": "MOYU Notebook",
    "MOYU Agenda": "MOYU Agenda",
    "MOYU Flipstone": "MOYU Flipstone",
    "MOYU Speelboek": "MOYU Game Book",
    "Uitwisbaar steenpapieren notebook. Schrijf, veeg, schrijf opnieuw.": "Erasable stone paper notebook. Write, wipe, write again.",
    "Steenpapieren agenda voor wie op papier blijft plannen.": "Stone paper agenda for those who plan on paper.",
    "Brainstorm flipover van steenpapier. Volledig uitwisbaar, herbruikbaar.": "Brainstorm flipover made of stone paper. Fully erasable, reusable.",
    "Uitwisbaar speelboek met 12 pen-en-papier klassiekers. Voor reizen of de wachtkamer.": "Erasable game book with 12 pen-and-paper classics. For travel or the waiting room.",
    "vanaf 19,95 euro": "from 19.95 euro",
    "vanaf 24,95 euro": "from 24.95 euro",
    "vanaf 49,95 euro": "from 49.95 euro",
    "Bekijk": "View",
    "Bekijk alles op moyu-notebooks.com": "See everything on moyu-notebooks.com",
    "Vanaf 1,30 euro": "From 1.30 euro",
    "per usage, ex BTW": "per usage, ex VAT",
    "Vraag een sample aan": "Request a sample",
    "Stonepacker via BOXO": "Stonepacker via BOXO",
    "Stonepacker maatwerk": "Stonepacker custom",
    "Op aanvraag": "On request",
    "obv volume en specs": "based on volume and specs",
    "Plan offerte-call": "Schedule quote call",
    "Twee manieren om": "Two ways to ship",
    "circulair te verzenden": "circular",
    "Stuur je naar klanten of pak je intern producten over tussen locaties? Voor allebei is er een Stonepacker-model. Allebei tot 25 keer herbruikbaar.": "Are you shipping to customers or moving products between locations? There's a Stonepacker model for both. Both reusable up to 25 times.",
    "1,30 euro per usage, geen abonnement": "1.30 euro per usage, no subscription",
    "2.500+ BOXO inleverpunten in NL": "2,500+ BOXO drop-off points in NL",
    "Wij verzorgen retourstroom en reiniging": "We handle return flow and cleaning",
    "Geen voorraadrisico, gewoon nabestellen": "No inventory risk, just reorder",
    "Voor RTP en cross-dock. Eigen formaten, eigen branding. Tot 25x herbruikbaar binnen je eigen loop.": "For RTP and cross-dock. Custom formats, custom branding. Up to 25x reusable in your own loop.",
    "Eigen formaten op aanvraag": "Custom formats on request",
    "Logo of kleurprint mogelijk": "Logo or color print possible",
    "Geschikt voor RTP en cross-dock": "Suitable for RTP and cross-dock",
    "Volume-staffel voor 1.000+ stuks": "Volume tier from 1,000 units",
    "KLM": "KLM",
    "Rituals": "Rituals",
    "Politie NL": "Dutch Police",
    "NIKE": "NIKE",
    "Ahold Delhaize": "Ahold Delhaize",
    "Boston Consulting Group": "Boston Consulting Group",
    "McKinsey": "McKinsey"
  };

  // Build a normalized lookup for whitespace-flexible matching
  const NORMALIZED_DICT = {};
  Object.keys(NL_TO_EN).forEach(function(k) { NORMALIZED_DICT[norm(k)] = NL_TO_EN[k]; });

  const STORAGE_KEY = 'sp-lang';
  let currentLang = localStorage.getItem(STORAGE_KEY) || 'nl';
  const originalTexts = new Map();

  function walkAndTranslate(root, lang) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function(node) {
        if (!node.parentElement) return NodeFilter.FILTER_REJECT;
        const tag = node.parentElement.tagName;
        if (tag === 'SCRIPT' || tag === 'STYLE') return NodeFilter.FILTER_REJECT;
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    const nodes = [];
    let n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(function(node) {
      const trimmed = node.nodeValue.trim();
      const normalized = norm(node.nodeValue);
      if (lang === 'en') {
        if (!originalTexts.has(node)) originalTexts.set(node, node.nodeValue);
        // Try direct match first, then normalized whitespace
        let translation = NL_TO_EN[trimmed] || NORMALIZED_DICT[normalized];
        if (translation) {
          // Replace just the trimmed portion, preserve outer whitespace
          node.nodeValue = node.nodeValue.replace(trimmed, translation);
        }
      } else {
        if (originalTexts.has(node)) node.nodeValue = originalTexts.get(node);
      }
    });
    document.querySelectorAll('[placeholder]').forEach(function(el) {
      const orig = el.dataset.spOrigPlaceholder || el.placeholder;
      if (!el.dataset.spOrigPlaceholder) el.dataset.spOrigPlaceholder = el.placeholder;
      const t = NL_TO_EN[orig] || NORMALIZED_DICT[norm(orig)];
      el.placeholder = (lang === 'en' && t) ? t : orig;
    });
  }

  function setLang(lang) {
    currentLang = lang;
    localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.setAttribute('lang', lang);
    document.documentElement.setAttribute('data-sp-lang', lang);
    walkAndTranslate(document.body, lang);
    document.querySelectorAll('[data-sp-lang-btn]').forEach(function(btn) {
      const isActive = btn.dataset.spLangBtn === lang;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function init() {
    document.querySelectorAll('[data-sp-lang-btn]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        setLang(btn.dataset.spLangBtn);
      });
    });
    setLang(currentLang);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
